var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h4',{staticClass:"small-caps"},[_vm._v("Primeira Hora")]),_c('div',{staticClass:"list-group"},_vm._l((_vm.articleList),function(article){return _c('SmallArticle',{key:article.identifier,attrs:{"identifier":`${article.identifier}`,"article":article.content,"mountedCallback":_vm.mountConfirmation}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }